import { Icon } from '@/components/icon';
import { useTheme } from '@/theme/hooks';
import { cn } from '@/utils';
import { NavLink } from 'react-router';
import logoImage from '../../assets/images/logo.png';

interface Props {
  size?: number | string;
  className?: string;
}
function Logo({ size = 50, className }: Props) {
  const { themeTokens } = useTheme();

  return (
    <NavLink to="/" className={cn(className)}>
      <Icon
        icon={`url:${logoImage}`}
        color={themeTokens.color.palette.primary.default}
        size={size}
      />
    </NavLink>
  );
}

export default Logo;
